<template>
  <ModalFilterTransaction v-if="modalShowFilterTransaction" :filter="filter" @closeModal="closeModal"
    @submitFilter="submitFilter" />
  <IndexView />
  <section class="p-6">
    <PageTitle title="Laporan Transaksi" />
    <div class="bg-white rounded-lg py-6 px-5 shadow-lg">
      <div v-if="!isConnected" class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4" role="alert">
        <p class="font-bold">Connection Status</p>
        <p>Attempting to connect to real-time updates...</p>
      </div>
      <div id="table-header" class="mb-5 flex justify-between items-end">
        <div class="mb-5 flex justify-between">
          <AddButton to_url="#" button_text="Filter" button_class="text-base py-2 font-medium" @click="showModal" />
          <AddButton to_url="#" button_text="Download Excel" button_class="text-base py-2 mx-3 font-medium"
            @click="exportExcel" />
        </div>
      </div>
      <div v-if="isLoading" class="flex justify-center items-center py-4">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
      <div v-else class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden shadow-lg rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-color-1">
                <tr>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Tanggal</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Jumlah Transaksi</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Produk Terjual</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Qty Order</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Qty Cancel</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Qty Complimentary</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Qty Terjual</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Sub Total</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">Grand Total</th>
                </tr>
              </thead>
              <tbody>

                <template v-for="dateGroup in salesOrders" :key="dateGroup.date">
                  <!-- Main Row for Each Date -->
                  <tr>
                    <td class="py-3 px-3 border-b text-left">{{ dateGroup.date }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ dateGroup.sales_order_count }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ dateGroup.unique_items_sold.length }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ dateGroup.total_products_ordered }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ dateGroup.total_products_canceled }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ dateGroup.total_products_complimentary }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ dateGroup.total_products_sold }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ formatRupiah(dateGroup.sub_total) }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ formatRupiah(dateGroup.grand_total) }}</td>
                  </tr>

                  <!-- Nested Rows for Unique Items Sold -->
                  <tr v-for="item in dateGroup.unique_items_sold" :key="`${dateGroup.date}-${item.item_id}`">
                    <td></td>
                    <td class="py-3 px-3 border-b text-left pl-6" colspan="2">↳ {{ item.item.code }} - {{ item.item.name
                    }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ item.ordered.total_qty }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ item.canceled.total_qty }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ item.complimentary.total_qty }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ item.sold.total_qty }}</td>
                    <!-- <td class="py-3 px-3 border-b text-left">{{ item.total_qty }}</td> -->
                    <td class="py-3 px-3 border-b text-left">{{ formatRupiah(item.subtotal) }}</td>
                    <td class="py-3 px-3 border-b text-left">{{ formatRupiah(item.grandtotal) }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
            <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
          </div>
          <Accordion>
            <AccordionPanel value="0">
              <AccordionHeader>Ringkasan Daily</AccordionHeader>
              <AccordionContent>
                <div class="mt-6 bg-white dark:bg-dark-800 p-4 rounded-lg shadow">
                  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Transaksi</p>
                      <p class="text-xl font-semibold">{{ sumSalesOrder }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Item Ordered</p>
                      <p class="text-xl font-semibold">{{ sumTotalProductsOrdered }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Item Canceled</p>
                      <p class="text-xl font-semibold">{{ sumTotalProductsCanceled }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Item Terjual</p>
                      <p class="text-xl font-semibold">{{ sumTotalItemsOrdered }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Item Complimentary</p>
                      <p class="text-xl font-semibold">{{ sumTotalItemsComplimentary }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Produk Terjual</p>
                      <p class="text-xl font-semibold">{{ sumUniqueItemsSold }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Sub Total</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(sumSubTotal) }}</p>
                    </div>
                    <div class="bg-gray-50 dark:bg-dark-700 p-4 rounded">
                      <p class="text-sm text-gray-500 dark:text-gray-400">Total Grand Total</p>
                      <p class="text-xl font-semibold">{{ formatRupiah(sumGrandTotal) }}</p>
                    </div>
                  </div>
                </div>
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PageTitle from "@/components/PageTitle.vue";
  import IndexView from "@/views/IndexView.vue";
  import AddButton from "@/components/buttons/AddButton.vue";
  import ModalFilterTransaction from "./modals/ModalFilterTransaction.vue";
  import { io } from "socket.io-client";
  import { mapGetters } from "vuex";
  import { formatRupiah } from "@/helpers/formatRupiah";
  import * as XLSX from 'xlsx';
  import PaginationButtons from '@/components/PaginationButtons.vue';
import { Accordion, AccordionPanel, AccordionHeader, AccordionContent } from "primevue";

  export default {
    name: "TransactionView",
    components: {
      PageTitle,
      IndexView,
      AddButton,
      ModalFilterTransaction,
      PaginationButtons,
      Accordion,
      AccordionPanel,
      AccordionHeader,
      AccordionContent,
    },
    data() {
      return {
        modalShowFilterTransaction: false,
        isBlur: false,
        listTransaction: [],
        allSalesOrders: [],
        socket: null,
        message: "",
        messages: [],
        isConnected: false,
        isLoading: false,
        currentPage: 1,
        totalPages: 1,
        itemsPerPage: 10,
        filter: {},
      };
    },
    async created() {
      this.connectWebSocket();
      this.fetchSalesOrders();
      this.fetchAdditionalData();
    },
    computed: {
      // ...mapGetters('sales_orders', ['allSalesOrders']),
      ...mapGetters('tables', ['allTables']),
      ...mapGetters('marketings', ['allMarketings']),
      ...mapGetters('payment_methods', ['allPaymentMethods']),
      salesOrders() {
        return this.allSalesOrders.slice(
          (this.currentPage - 1) * this.itemsPerPage,
          this.currentPage * this.itemsPerPage
        );
      },
      sumSalesOrder() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.sales_order_count), 0);
      },
      sumUniqueItemsSold() {
        return this.allSalesOrders.reduce((total, order) => total + order?.unique_items_sold?.length, 0);
      },
      sumTotalProductsOrdered() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.total_products_ordered), 0);
      },
      sumTotalItemsOrdered() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.total_products_sold), 0);
      },
      sumTotalProductsCanceled() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.total_products_canceled), 0);
      },
      sumTotalItemsComplimentary() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.total_products_complimentary), 0);
      },
      sumTotalProductsSold() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.total_products_sold), 0);
      },
      sumSubTotal() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.sub_total), 0);
      },
      sumGrandTotal() {
        return this.allSalesOrders.reduce((total, order) => total + Number(order.grand_total), 0);
      },
    },
    beforeUnmount() {
      try {
        if (this.socket) {
          // Remove all listeners to prevent memory leaks
          this.socket.removeAllListeners();
          this.socket.disconnect();
          this.socket = null;
        }
        this.isConnected = false;
        this.listTransaction = [];
        this.messages = [];
      } catch (error) {
        console.error("Error during cleanup:", error);
      }
    },
    watch: {
      currentPage: {
        immediate: true,
        handler(newVal) {
          this.fetchSalesOrders({ page: newVal });
          this.currentPage = newVal;
        },
      },
    },
    methods: {
      formatRupiah,
      async fetchSalesOrders(params = {}) {
        const { data } = await this.$store.dispatch('reports/fetchDailySalesOrders', { ...params, limit: 1000000 });
        this.allSalesOrders = data;
        this.totalPages = data.length > 0 ? Math.ceil(data.length / this.itemsPerPage) : 1;
      },
      async fetchAdditionalData() {
        this.$store.dispatch('tables/fetchTables', { limit: 1000 });
        this.$store.dispatch('marketings/fetchMarketings', { limit: 1000 });
        this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
      },
      connectWebSocket() {
        try {
          this.socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
            reconnection: true, // Enable auto-reconnection
            reconnectionAttempts: 5, // Maximum number of reconnection attempts
            timeout: 10000, // Connection timeout in milliseconds
          });

          this.socket.on("connect_error", (error) => {
            this.messages.push(error.message);
            this.isConnected = false;
          });

          this.socket.on("disconnect", (reason) => {
            this.messages.push(reason);
            this.isConnected = false;
          });

          // Menerima pesan dari server
          this.socket.on("serverMessage", (data) => {
            this.handleWebSocketMessage(data);
            this.messages.push(data.message);
          });

          this.socket.on("welcome", (data) => {
            this.messages.push(data.message);
          });

          this.socket.on("new_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("update_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("delete_items", (order) => {
            this.handleWebSocketMessage(order);
          });

          this.socket.on("connect", () => {
            this.isConnected = true;
          });

          this.socket.on("error", (error) => {
            this.messages.push(error.message);
            this.isConnected = false;
          });

          this.handleReconnect();
        } catch (error) {
          this.isConnected = false;
        }
      },
      sendMessage() {
        // Kirim pesan ke server
        this.socket.emit("clientMessage", this.message);
        this.message = ""; // Reset input
      },
      handleWebSocketMessage(data) {
        this.isLoading = true;
        try {
          let index;

          // Validasi data terlebih dahulu
          if (!data || !data.type) {
            return;
          }

          switch (data.type) {
            case "INITIAL_DATA":
              if (Array.isArray(data.transactions)) {
                this.listTransaction = data.transactions;
                this.fetchSalesOrders();
              } else {
                console.warn("Invalid transactions data format:", data);
              }
              break;
            case "NEW_ITEMS":
              if (data.items && data.route == "sales-order") {
                this.listTransaction.unshift(data.items);
                this.fetchSalesOrders();
              }
              break;
            case "UPDATE_ITEMS":
              if (data.items && data.items.id && data.route == "sales-order") {
                index = this.listTransaction.findIndex(
                  (t) => t.id === data.items.id
                );
                if (index !== -1) {
                  this.listTransaction.splice(index, 1, data.items);
                }
                this.fetchSalesOrders();
              }
              break;
            case "DELETE_ITEMS":
              if (data.id && data.route == "sales-order") {
                this.listTransaction = this.listTransaction.filter(
                  (transaction) => String(transaction.id) !== String(data.id)
                );
                this.fetchSalesOrders();
              }
              break;
            default:
              console.warn("Unknown message type:", data.type);
          }
        } catch (error) {
          console.error("Error handling websocket message:", error);
        } finally {
          this.isLoading = false;
        }
      },
      handleReconnect() {
        if (this.socket) {
          this.socket.on("reconnect_attempt", (attemptNumber) => {
            console.log(`Reconnection attempt ${attemptNumber}`);
          });

          this.socket.on("reconnect", () => {
            console.log("Reconnected successfully");
            this.isConnected = true;
            // Mungkin perlu memuat ulang data
            this.socket.emit("requestInitialData");
          });

          this.socket.on("reconnect_failed", () => {
            console.log("Failed to reconnect");
            this.isConnected = false;
          });
        }
      },
      showModal() {
        this.modalShowFilterTransaction = true;
        this.isBlur = true;
      },
      closeModal() {
        setTimeout(() => {
          this.modalShowFilterTransaction = false;
          this.isBlur = false;
        }, 200);
      },
      submitFilter(filter) {
        let params = {};
        if (filter.capacity) {
          params.capacity = filter.capacity;
        }

        if (filter.type) {
          params.order_type = filter.type;
        }

        if (filter.status) {
          params.status = filter.status;
        }

        if (filter.marketing_id) {
          params.marketing_id = filter.marketing_id;
        }

        if (filter.global_discount_id) {
          params.global_discount_id = filter.global_discount_id;
        }

        if (filter.item_category_id) {
          params.item_category_id = filter.item_category_id;
        }

        if (filter.payment_method_id) {
          params.payment_method_id = filter.payment_method_id;
        }

        if (filter.table_id) {
          params.table_id = filter.table_id;
        }

        if (filter.cash_register_id) {
          params.cash_register_id = filter.cash_register_id;
        }

        if (filter.rangeDate) {
          params.start_date = filter.rangeDate[0];
          params.end_date = filter.rangeDate[1];
        }

        this.fetchSalesOrders(params);

        // this.allSalesOrders.filter((so) => {
        //   return (
        //     (!filter.rangeDate && (filter.rangeDate && so.created_at >= filter.rangeDate[0] && so.created_at <= filter.rangeDate[1]))
        //   );
        // });

        this.updateFilter(filter);
      },
      updateFilter(filter) {
        this.filter = filter;
      },
      async exportExcel() {
        const workbook = XLSX.utils.book_new();
        const worksheetData = [];

        // Add header row
        worksheetData.push([
          'Tanggal',
          'Jumlah Transaksi',
          'Produk Terjual',
          'Qty Order',
          'Qty Cancel',
          'Qty Terjual',
          'Grand Total',
        ]);

        // Populate data rows
        this.allSalesOrders.forEach(dateGroup => {
          worksheetData.push([
            dateGroup.date,
            dateGroup.sales_order_count,
            dateGroup.unique_items_sold.length,
            dateGroup.total_products_ordered,
            dateGroup.total_products_canceled,
            dateGroup.total_products_sold,
            dateGroup.grand_total,
          ]);

          dateGroup.unique_items_sold.forEach(item => {
            worksheetData.push([
              '',
              '',
              `${item.item.code} - ${item.item.name}`,
              item.ordered.total_qty,
              item.canceled.total_qty,
              item.sold.total_qty,
              item.subtotal,
            ]);
          });
        });

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Daily Sales');

        // Generate Excel file and trigger download
        XLSX.writeFile(workbook, 'Daily_Sales_Report.xlsx');
      }
    },
  };
</script>
